import styles from '../styles/createForm.module.scss';
import { useEffect, useState } from 'react';
import { FormData } from '../model/interfaces';
import TextEditor from '@ui-kit/components/textEditor';
import { useController, useForm } from 'react-hook-form';
import MainButton from '@ui-kit/components/mainButton';

function FormWithEditor(props: {
  titleForm: string;
  placeholderInput: string;
  loading: boolean;
  requiredInput?: boolean;
  placeholderEditor: string;
  buttonTitle: string;
  initInputValue?: string;
  initMessageValue?: string;
  submit: (data: FormData) => void;
  threadState?: string;
  isFocus?: boolean;
}) {
  const { titleForm, placeholderEditor, placeholderInput, requiredInput, submit } = props;
  const [focusInput, setFocusInput] = useState(false);

  const { control, handleSubmit, register, setValue, formState, getValues, trigger } = useForm({
    mode: 'all',
    defaultValues: {
      subject: props.initInputValue ? props.initInputValue : '',
      message: props.initMessageValue ? props.initMessageValue : '',
      state: props.threadState ? props.threadState : '',
    },
  });

  const { field: message } = useController({ name: 'message', control });

  const submitCreate = handleSubmit(async (data) => {
    submit(data as FormData);
  });

  useEffect(() => {
    if (props.isFocus) setFocusInput(true);
  }, [props.isFocus]);
  useEffect(() => {
    trigger('subject');
    trigger('message');
  }, []);

  return (
    <div className={styles.createForm}>
      <h3>{titleForm}</h3>
      <form onSubmit={submitCreate}>
        {props.threadState && (
          <div className={styles.editState}>
            <div className={styles.radio}>
              <input type="radio" {...register('state', { required: true })} value="H" id="H" />
              <label htmlFor={'H'}>Hidden</label>
            </div>
            <div className={styles.radio}>
              <input type="radio" {...register('state', { required: true })} value="L" id="L" />
              <label htmlFor={'L'}>Locked</label>
            </div>
            <div className={styles.radio}>
              <input type="radio" {...register('state', { required: true })} value="O" id="O" />
              <label htmlFor={'O'}>Opened</label>
            </div>
          </div>
        )}
        <input
          id="forumSubjectInput"
          className={styles.subjectInput}
          placeholder={placeholderInput}
          autoFocus={focusInput}
          {...register('subject', { required: requiredInput })}
        />
        <div className={styles.createEditor}>
          <TextEditor
            initData={props.initMessageValue}
            placeholder={placeholderEditor}
            {...message}
            onChange={(evt) => {
              setValue('message', evt.editor.getData().replace(/<br \/>/g, ''));
            }}
          />
          <div className={styles.buttons}>
            <MainButton type="submit" loading={props.loading} disabled={!formState.isValid || !getValues('message').length}>
              {props.buttonTitle}
            </MainButton>
          </div>
        </div>
      </form>
    </div>
  );
}

export default FormWithEditor;
